import { render } from "./BoozelogView.vue?vue&type=template&id=31e0b98f&scoped=true&ts=true"
import script from "./BoozelogView.vue?vue&type=script&lang=ts"
export * from "./BoozelogView.vue?vue&type=script&lang=ts"

import "./BoozelogView.vue?vue&type=style&index=0&id=31e0b98f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31e0b98f"]])

export default __exports__